import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { BarChartOutlined, BankOutlined, UserOutlined, ShopOutlined } from '@ant-design/icons';
import './FacilityStatisticsPage.css';

const FacilityStatisticsPage: React.FC = () => {
  return (
    <div className="facility-statistics-page">
      <h1>Thống kê</h1>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Tổng số CSYT"
              value={112}
              prefix={<BankOutlined />}
              valueStyle={{ color: '#385da4' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="CSYT hoạt động"
              value={98}
              prefix={<BankOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Tổng số User"
              value={256}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Nhà cung cấp"
              value={45}
              prefix={<ShopOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Biểu đồ thống kê CSYT" style={{ height: 400 }}>
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <BarChartOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />
              <p style={{ marginTop: 16, color: '#999' }}>Biểu đồ sẽ được hiển thị ở đây</p>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Biểu đồ thống kê User" style={{ height: 400 }}>
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <BarChartOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />
              <p style={{ marginTop: 16, color: '#999' }}>Biểu đồ sẽ được hiển thị ở đây</p>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default FacilityStatisticsPage;
